'use client';

/**
 * Shows the active CSS breakpoint in a fixed debug badge.
 * Uses hidden Tailwind utility divs to detect the current breakpoint —
 * no JS resize listeners needed, pure CSS.
 */

const BreakpointBadge = () => {
  return (
    <div className="ph-no-capture fixed bottom-8 right-20 z-[60] rounded bg-blue-700 px-2 py-1 font-mono text-[10px] font-bold text-white shadow-sm opacity-90">
      <span className="mobile:hidden">xs</span>
      <span className="hidden mobile:inline tablet:hidden">mobile</span>
      <span className="hidden tablet:inline desktop:hidden">tablet</span>
      <span className="hidden desktop:inline large-desktop:hidden">
        desktop
      </span>
      <span className="hidden large-desktop:inline">lg-desktop</span>
      <span className="ml-1 opacity-60">
        <span className="mobile:hidden">{'<'}480</span>
        <span className="hidden mobile:inline tablet:hidden">480</span>
        <span className="hidden tablet:inline desktop:hidden">700</span>
        <span className="hidden desktop:inline large-desktop:hidden">1100</span>
        <span className="hidden large-desktop:inline">1500</span>
      </span>
    </div>
  );
};

export default BreakpointBadge;
